import clientAuth from "../clientAuth";
import client from "../client";

export default {
register:(userData)=>client.post('registration/create', { json: userData }),
login:(userData)=>client.post('login', { json: userData }),

};